import React from "react";
import { Box } from "@mui/material";
import ProjectGroupCard from "./components/ProjectGroupCard";

/**
 * 一覧全体の管理
 * グループ化済みのカードを並べる
 */
export default function SkillSheetMainSummaryList({
  workHistoryGroups = [],
  phases = [
    { key: "requirement_definition", label: "要件\n定義" },
    { key: "basic_design", label: "基本\n設計" },
    { key: "detail_design", label: "詳細\n設計" },
    { key: "program", label: "製造\n構築" },
    { key: "test", label: "テス\nト" },
    { key: "maintenance_operation", label: "保守\n運用" },
  ],
  page = 1,
  per = 10,
  selectedWorkHistoryIds = [],
  onSelectedWorkHistoryIdsChange,
  onRemoveFromGroup,
  onUngroup,
  processing = false,
}) {
  const toggleSelected = (workHistoryId) => {
    if (!onSelectedWorkHistoryIdsChange) return;

    onSelectedWorkHistoryIdsChange((prevIds) => {
      if (prevIds.includes(workHistoryId)) {
        return prevIds.filter((id) => id !== workHistoryId);
      }

      return [...prevIds, workHistoryId];
    });
  };

  return (
    <Box sx={{ display: "grid", gap: 3 }}>
      {workHistoryGroups.map((group, index) => (
        <ProjectGroupCard
          key={group.key}
          group={group}
          displayIndex={(page - 1) * per + index + 1}
          phases={phases}
          selectedWorkHistoryIds={selectedWorkHistoryIds}
          processing={processing}
          onToggleSelected={toggleSelected}
          onRemoveFromGroup={onRemoveFromGroup}
          onUngroup={onUngroup}
        />
      ))}
    </Box>
  );
}
